import { Form, Formik } from "formik";
import { object, string } from 'yup';
import { useSelector } from "react-redux";
import FieldsCobro from "./FieldsCobro";
import SubmitButton from "../c&m/facturacion/SubmitButton";
import Axios from "axios";
import Cookies from "universal-cookie";
import { Tab } from "@headlessui/react";

const Cobro = ({ setLoading, setModal, options }) => {

    const {IdSede, IdSemestre, IdEmp} = useSelector(state => state.auth);

    const cookies = new Cookies();
    const urlSchoolApi = cookies.get('__urlSchoolApi');
    const { headersAPI: headers } = useSelector(state => state.url)

    //Manejo de post
    const fetchData = async (data) => {
        setLoading(true);
        try {
            await Axios({
                method: 'POST',
                url: urlSchoolApi + '/pagos/pagosparqueo',
                headers,
                data
            });

            setLoading(false);

            setModal({
                msg: '¡Marbete realizado con exito!',
                ok: true,
                show: true,
                reload: true
            });

        } catch (err) {
            setModal({
                ok: false,
                msg: 'Por favor intentelo de nuevo.',
                show: true,
                reload: true
            })

            console.log(err);

        };
    }

    const handlePost = async (values) => {
        const { Semestre, Valor, ...rest } = values;

        const data = JSON.stringify({
            ...rest,
            HostName: 'DEV07',
            IpHost:"131.107.1.235",
            OS:"Windows"
        });

        fetchData(data);
    };

    return(
        <Formik
            initialValues={{
                //Datos alumno
                Carnet: '',
                Nombre: '',
                Email: '',
                Email2: '',
                Celular: '',
                //Datos recibo
                CanalPago: 5,
                IdEmp,
                IdSede,
                IdCargo: '',
                IdSemestre,
                Semestre: '',
                Valor: '',
                //Datos carro
                IdMarca: '',
                Marca: '',
                IdColor: '',
                Color: '',
                Placa: '',
            }}
            validationSchema={object({
                //Datos alumno
                Carnet: string().required('Dato obligatorio'),
                Nombre: string().required('Dato obligatorio'),
                Email:  string().required('Dato obligatorio'),
                Email2: string()
                    .required('')
                    .test(
                        'SAME_EMAIL', 
                        'Correo electrónico no coincide', 
                        (value, context) => context.parent.Email === value,
                    ),
                Celular:  string().required('Dato obligatorio'),
                //Datos recibo
                IdCargo:  string().required('Dato obligatorio'),
                Valor:    string().required('Dato obligatorio'),
                Semestre: string().required('Dato obligatorio'),
                //Datos carro
                IdMarca: string().required('Dato obligatorio'),
                Marca:   string().required('Dato obligatorio'),
                IdColor: string().required('Dato obligatorio'),
                Color:   string().required('Dato obligatorio'),
                Placa:   string()
                    .required('')
                    .test(
                        'CARNO_ERR',
                        'Número de placa incorrecto',
                        value => {
                            const regexp = /^[0-9]{3}[A-Z|ÁÉÍÓÚ|a-z|áéíóú|\s]{3}$/
                            if (value?.length > 0) {
                                return regexp.test(value);
                            }

                            return true;
                        }
                    ),
            })}
            onSubmit={handlePost}
        >
            { ({setFieldValue, values, touched, errors}) => {

                    return(
                        <Form>
                            <Tab.Panel className="w-full bg-primarioMira p-5 rounded-lg shadow-2xl flex flex-col gap-5 max-w-[64rem] mx-auto">
                                <div className="lg:grid lg:grid-cols-3 lg:gap-5">
                                    <div className="lg:col-span-1 lg:ml-11 lg:mt-5">
                                        <h3 className="text-lg font-medium leading-6 text-white">Ingresar datos</h3>
                                        <p className="py-2 text-sm text-grisMira">Rellene la información respectiva al estudiante, vehiculo y recibo para generar marbete.</p>
                                    </div>
                                    <div className="lg:col-span-2 lg:mr-5 mt-5">
                                        <FieldsCobro
                                            setFieldValue={setFieldValue}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            options={options}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <SubmitButton
                                        className="px-0"
                                        label='Generar marbete'
                                    />
                                </div>
                            </Tab.Panel>
                        </Form>
                    )
                }
            }
        </Formik>
    );
};

export default Cobro